// axios也走cdn
// import axios from 'axios'
// import { mapActions } from 'vuex'

/* global axios */
import Store from '../store'
import { baseUrl } from '../lib/config.js'

const service = axios.create()

// Add a response interceptor
service.interceptors.request.use((config) => {
  // Do something before request is sent
  Store.dispatch('switchMum', true)
  let url = config.url
  let reg = /http/g
  if (!reg.test(url)) {
    url = `${baseUrl}/${url}`
  }
  config.url = url
  config.withCredentials = true
  config.crossDomain = true
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

service.interceptors.response.use((response) => {
  Store.dispatch('switchMum', false)
  if (response.data.status) {
    return response.data.data
  } else {
    Store.dispatch('playMsg', response.data.description || '网络请求错误')
    return Promise.reject(response.data.description)
  }
}, (error) => {
  Store.dispatch('switchMum', false) // 如果菊花不消失，用户无法做任何操作
  return Promise.reject(error)
})

export default service
